(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pidelo-pdp-cta"]) return;
  try {
    
(function () {
  'use strict';

  var wrapper = document.querySelector('.pidelo-pdp-cta[data-section-id]');
  if (!wrapper) return;

  var bar = wrapper.querySelector('.pidelo-pdp-cta__bar');
  var amount = wrapper.querySelector('.pidelo-pdp-cta__amount');
  var reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  // Contrato [data-pidelo-order-form]: el mecanismo de entrega vigente debe
  // marcar su formulario con ese atributo (docs/adr/0037) y así el CTA deja
  // de acoplarse al proveedor. La lista legacy mantiene funcionando a
  // Releasit hoy sin decorar; se borra cuando el marcador sea el único
  // camino. La misma lista sirve para el scroll y el límite de ocultamiento.
  var FORM_CANDIDATES = [
    '[data-pidelo-order-form]',
    '.releasit-cod-form',
    '[id*="releasit" i]',
    '[class*="releasit" i]',
    '.shopify-app-block',
    '[data-shopify-app-block]',
  ];

  // Objetivo del scroll: el formulario Releasit cuando exista; en su defecto la
  // sección de apps previa o el cierre del contenido principal.
  function resolveTarget() {
    for (var i = 0; i < FORM_CANDIDATES.length; i++) {
      var nodes = document.querySelectorAll(FORM_CANDIDATES[i]);
      if (nodes.length) return nodes[nodes.length - 1];
    }
    if (wrapper.previousElementSibling) return wrapper.previousElementSibling;
    return document.querySelector('#MainContent');
  }

  // Límite de ocultamiento: únicamente el formulario de la app. Los fallbacks
  // genéricos valen para desplazar la vista, pero observarlos haría que la
  // barra desapareciera en cuanto cualquier parte del contenido entrara al
  // viewport. Releasit inyecta su formulario después de cargar, así que se
  // vuelve a intentar en cada cambio del DOM hasta encontrarlo.
  function findBoundary() {
    for (var i = 0; i < FORM_CANDIDATES.length; i++) {
      var nodes = document.querySelectorAll(FORM_CANDIDATES[i]);
      if (nodes.length) return nodes[nodes.length - 1];
    }
    return null;
  }

  function hideBar(hidden) {
    wrapper.classList.toggle('is-hidden', hidden);
    bar.setAttribute('aria-hidden', hidden ? 'true' : 'false');
  }

  // Precio vivo: copia el precio visible del producto y sigue sus cambios de
  // variante. La lectura se repite en cada aviso porque Dawn sustituye el
  // interior del contenedor de precio al cambiar la variante y el nodo inicial
  // queda fuera del DOM; el observer se ancla al envoltorio estable del bloque
  // de información para sobrevivir a ese reemplazo.
  function bindPrice() {
    if (!amount) return;
    var anchor =
      document.querySelector('.product__info-container') ||
      document.querySelector('.price__container') ||
      document.querySelector('.price');
    if (!anchor) return;
    var sync = function () {
      // Orden de resolución: precio vigente en oferta primero; si no hay,
      // el primer price-item--regular que no sea el anterior tachado ni un
      // precio por unidad. El <s> del precio previo, la clase variant-item
      // __old-price y el small.unit-price quedan excluidos por contrato.
      var source = anchor.querySelector('.price__sale .price-item--sale.price-item--last');
      if (!source) {
        var regulars = anchor.querySelectorAll('.price-item--regular');
        for (var i = 0; i < regulars.length; i++) {
          var candidate = regulars[i];
          if (candidate.closest('s') || candidate.closest('small.unit-price')) continue;
          if (candidate.className.indexOf('variant-item__old-price') !== -1) continue;
          source = candidate;
          break;
        }
      }
      amount.textContent = ((source && source.textContent) || '').trim();
    };
    sync();
    try {
      new MutationObserver(sync).observe(anchor, {
        childList: true,
        subtree: true,
        characterData: true,
      });
    } catch (error) {
      /* precio estático */
    }
  }

  // Disparo por borde: en cuanto cualquier parte del formulario entra al tramo
  // inferior del viewport escondemos la barra, porque ahí suele activarse el
  // pie pegajoso propio del formulario y dos barras fijas se empalman.
  var boundary = null;
  var watcher = null;
  var boundaryInView = false;
  var hideObserver =
    'IntersectionObserver' in window
      ? new IntersectionObserver(
          function (entries) {
            boundaryInView = entries[0].isIntersecting;
            hideBar(entries[0].isIntersecting);
          },
          { rootMargin: '0px 0px -14% 0px', threshold: 0 },
        )
      : null;

  function bindBoundary() {
    if (!hideObserver || boundary) return;
    var found = findBoundary();
    if (!found) return;
    boundary = found;
    hideObserver.observe(boundary);
    stopWatcher();
  }

  // Tope temporal del watcher global: si ninguna app inyecta formulario
  // (p. ej. un día sin Releasit), dejar el observer del documento corriendo
  // para siempre cuesta lecturas en cada mutación de la página.
  var WATCHER_TIMEOUT_MS = 15000;
  var watcherTimer = null;

  function stopWatcher() {
    if (watcherTimer !== null) {
      clearTimeout(watcherTimer);
      watcherTimer = null;
    }
    window.removeEventListener('pagehide', stopWatcher);
    if (watcher) {
      watcher.disconnect();
      watcher = null;
    }
  }

  if (hideObserver && 'MutationObserver' in window) {
    watcher = new MutationObserver(bindBoundary);
    watcher.observe(document.documentElement, { childList: true, subtree: true });
    window.addEventListener('pagehide', stopWatcher);
    watcherTimer = setTimeout(stopWatcher, WATCHER_TIMEOUT_MS);
  }
  bindBoundary();

  bar.addEventListener('click', function () {
    var target = resolveTarget();
    if (!target) return;
    target.scrollIntoView({
      behavior: reducedMotion ? 'auto' : 'smooth',
      block: 'start',
    });
  });

  // El teclado del formulario tiene prioridad: sin barra encima mientras se escribe.
  document.addEventListener('focusin', function (event) {
    if (boundary && boundary.contains(event.target)) hideBar(true);
  });
  document.addEventListener('focusout', function () {
    hideBar(boundaryInView);
  });

  bindPrice();
})();

  } catch(e) { console.error(e); }
})();
})();
